function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var Swal = require(261);
var isSANB = require(160);
module.exports = function () {
  if (_typeof(window._messages) === 'object') {
    var steps = [];
    for (var _i = 0, _Object$keys = Object.keys(window._messages); _i < _Object$keys.length; _i++) {
      var type = _Object$keys[_i];
      var messages = window._messages[type];
      if (messages.length === 0) continue;
      var _iterator = _createForOfIteratorHelper(messages),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var message = _step.value;
          if (type === 'custom' && _typeof(message) === 'object') {
            // render any full screen alerts immediately
            // eslint-disable-next-line max-depth
            if (message.grow === 'fullscreen') {
              steps.unshift(message);
            } else {
              steps.push(message);
            }
          } else if (typeof message === 'string') {
            steps.push({
              title: _typeof(window._types) === 'object' && isSANB(window._types[type]) ? window._types[type] : type,
              html: message,
              type: _typeof(window._types) === 'object' && isSANB(window._types[type]) ? type : null
            });
          } else {
            var error = new Error("Unknown message type of \"".concat(message, "\"."));
            // eslint-disable-next-line max-depth
            if (_typeof(window.cabin) === 'object' && typeof window.cabin.error === 'function') window.cabin.error(error);else console.error(error);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (steps.length > 0) Swal.queue(steps);
  }

  // clear window._messages
  window._messages = {};

  // delete script tag that contained messages
  // (e.g. in case we generate passwords in `_messages`)
  $('#flash-messages').remove();
};
//# sourceMappingURL=flash.js.map